import React, { useState, useEffect } from 'react';
import { Input } from '../Input';
import CheckboxUI from './CheckboxUI';

export default function CheckboxInput({
  setFormValue,
  value = false,
  name,
  text,
  children,
  onChange,
  ...otherProps
}) {
  const [optionValue, setOptionValue] = useState(value || false);
  const id = `checkbox-${name}`;

  useEffect(() => {
    setOptionValue(value);
  }, [value]);

  function handleChange() {
    const newValue = !optionValue;
    setOptionValue(newValue);

    if (setFormValue) {
      setFormValue(name, newValue);
    }

    if (onChange) {
      onChange(newValue);
    }
  }

  const selected = !!optionValue;

  return (
    <Input {...otherProps} htmlId={id}>
      <CheckboxUI
        id={id}
        selected={selected}
        onClick={handleChange}
        label={text}
      />
    </Input>
  );
}
